/**
 * CL-ACCESS-PERMISSIONS-002B — Client-safe invoice capability keys (pure).
 */

export const CLIENT_SAFE_INVOICE_PERMISSION_KEYS = Object.freeze({
  issued: "canViewIssuedInvoices",
  clientTest: "canViewClientTestInvoices",
});

export const CLIENT_SAFE_INVOICE_PERMISSION_KEY_LIST = Object.freeze(
  Object.values(CLIENT_SAFE_INVOICE_PERMISSION_KEYS)
);

export const CLIENT_SAFE_INVOICE_PERMISSION_LABELS = Object.freeze({
  [CLIENT_SAFE_INVOICE_PERMISSION_KEYS.issued]:
    "View issued invoices shared with this user",
  [CLIENT_SAFE_INVOICE_PERMISSION_KEYS.clientTest]:
    "View client-test invoices shared with this user",
});

export function isClientSafeInvoicePermissionKey(key = "") {
  return CLIENT_SAFE_INVOICE_PERMISSION_KEY_LIST.includes(String(key ?? "").trim());
}

export function normalizeClientSafeInvoicePermissionsForAssignmentSave(
  permissions = {},
  { rawPermissions = null } = {}
) {
  const source = rawPermissions && typeof rawPermissions === "object" ? rawPermissions : permissions;
  const next = { ...(permissions || {}) };
  CLIENT_SAFE_INVOICE_PERMISSION_KEY_LIST.forEach((key) => {
    if (typeof source?.[key] === "boolean") {
      next[key] = source[key] === true;
      return;
    }
    delete next[key];
  });
  return next;
}
